import React from 'react'
import Label from "components/general/Label";
import { ColumnRank, ColumnName, ColumnNoc, ColumnResult, ColumnQualification, ColumnExpander } from "components/common/TableColumns"
import { findArray } from 'helpers/utils'
import { useViewport } from 'components/general/useViewPort'

import SportCode from 'components/common/SportCode';

function ColumnNeeds() {
    return (
        {
            Header: <Label data={"HeaderNeeds"} />,
            //accessor: 'itemType',
            className: 'text-end',
            headerClassName: 'text-end',
            disableSortBy: true,
            id: 'Needs',
            Cell: (props) => {
                if (props.cell.row.original?.extendedResults) {
                    return findArray(props.cell.row.original?.extendedResults, { er_code: ['NEED'] }).er_value;
                }
            }
        }
    )
}

function ColumnBib() {
    return (
        {
            Header: <Label data={"HeaderJersey"} />,
            accessor: 'bib',
            className: 'text-end',
            headerClassName: 'text-end w-5',
            disableSortBy: true,
            id: 'Bib',
            Cell: (props) => {
                let colour = findArray(props.cell.row.original?.eventUnitEntries, { eue_code: ['BIB_COLOUR'] }).eue_value;
                let priority = findArray(props.cell.row.original?.extendedResults, { er_code: ['PRIORITY'] }).er_value;

                return (
                    <div className={(colour) ? ('d-flex bg-' + colour).toLowerCase() : 'd-flex'}>
                        <div className="flex-fill text-start px-1">
                            {
                                //<SportCode code={priority} discipline="SRF" entity="@Priority"/>
                            }
                            {priority}
                        </div>
                        <div className="text-end px-1">{props.value}</div>
                    </div>
                )
            }
        }
    )
}

function ColumnBestScore(arrive) {
    return (
        {
            Header: <Label data={"HeaderBestScore" + arrive} />,
            className: 'text-end',
            headerClassName: 'text-end',
            disableSortBy: true,
            id: 'BestScore' + arrive,
            Cell: (props) => {
                let value = findArray(props.cell.row.original?.extendedResults, { er_code: ['WAVE'], er_arrive: [arrive] }).er_value
                let pty = findArray(props.cell.row.original?.extendedResults, { er_code: ['WAVE'], er_arrive: [arrive] }).er_pty
                let value2 = findArray(props.cell.row.original?.extendedResults, { er_code: ['WAVE'], er_arrive: [arrive] }).er_value2

                return (pty) ? <span>{value} ({pty} {value2})</span> : value
            }
        }
    )
}

export function TableColumnsStartList() {

    return (
        [
            ColumnBib(),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            ColumnResult({ label: "HeaderTotal" }),
            ColumnBestScore('1'),
            ColumnBestScore('2'),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumnsLive() {

    return (
        [
            ColumnRank({ disableSort: true, label: "HeaderPlace" }),
            ColumnBib(),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            ColumnResult({ disableSort: true, label: "HeaderTotal", className: "text-end fw-bold" }),
            ColumnBestScore('1'),
            ColumnBestScore('2'),
            ColumnNeeds(),
            ColumnQualification({ className: "text-end fw-bold" }),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumnsFinish() {
    return (
        [
            ColumnRank({ disableSort: true, label: "HeaderPlace" }),
            ColumnBib(),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            ColumnResult({ disableSort: true, label: "HeaderTotal", className: "text-end fw-bold" }),
            ColumnBestScore('1'),
            ColumnBestScore('2'),
            ColumnQualification({ className: "text-end fw-bold" }),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

